function errorMessage(context, message) {
    context.$swal({
        html: message + '<br><br>Por favor, <b><a href="https://telemidia.net.br/contato" target="_blank">clique aqui e entre em contato</a></b>, ou então <b><a href="https://api.whatsapp.com/send?phone=553537311118" target="_blank">clique aqui, se preferir nos chamar via WhatsApp</a></b>.'
    })
}

function downloadPdf(filename, base64) {
    const binary = atob(base64.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);

    for (let i = 0; i < len; i += 1) {
        view[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([view], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = url;
    a.download = filename;
    a.click();
}

function formatarTelefone(telefone) {
    // Formata a string
    const ddd = telefone.slice(0, 2); // Os dois primeiros dígitos
    const primeiroBloco = telefone.slice(2, 7); // Os próximos cinco dígitos
    const segundoBloco = telefone.slice(7); // Os últimos quatro dígitos

    const telefoneFormatado = `(${ddd}) ${primeiroBloco}-${segundoBloco}`;
    return telefoneFormatado;
}

exports.downloadPdf = downloadPdf
exports.formatarTelefone = formatarTelefone
exports.errorMessage = errorMessage